export const noop = (): void => {};
export const delay = (ms: number): Promise<void> => new Promise((resolve) => setTimeout(resolve, ms));
export const hasValue = <T>(value: T): boolean => value !== null && value !== undefined && value !== "";
